export const ADD_TO_FAVORITES = 'ADD_TO_FAVORITES';
export const REMOVE_FROM_FAVORITES = 'REMOVE_FROM_FAVORITES';
export const SHOW_FAVORITES_WEATHER = 'SHOW_FAVORITES_WEATHER';
export const SHOW_FIVE_DAY_WEATHER = 'SHOW_FIVE_DAY_WEATHER';
